﻿<script setup lang="ts">
    import { onMounted } from 'vue';
    import Theme from './Theme.vue';
    import ThemesList from './ThemesList.vue';
    import { setupThemes } from './Themes';

    let { themesState, createTheme, getThemes, editTheme, showEditorFunc, deleteSelected, updateSelected } = setupThemes();

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('newTheme')) createTheme();

    onMounted(async () => {
        await getThemes();
    });
</script>

<script lang="ts"></script>

<template>
    <div v-show="themesState.themeId === null">
        <h2 class="main-title">{{ $Resources.ThemesListHeading }}</h2>

        <ThemesList
            :themes="themesState.themes"
            :isLoading="themesState.isLoading"
            :themeId="themesState.themeId"
            :selected="themesState.selected"
            :createTheme="createTheme"
            :backoffice="false"
            @themeSelected="(newVal) => editTheme(newVal)"
            @updateSelected="(newVal) => updateSelected(newVal)"
            @clearSelected="themesState.selected = []"
            @deleteSelected="deleteSelected()"></ThemesList>
    </div>

    <Theme :themeId="themesState.themeId" :backoffice="false" v-show="themesState.themeId !== null" @update:showEditor="showEditorFunc"></Theme>
</template>

<style lang="less"></style>
